import PropTypes from "prop-types";
import React, { useState } from "react";
import SvgIcon from "../../../SvgIcon";
import { getUnitsOptions } from "../../profile/AddGoal";
import { PersonalRecordInlineForm } from "./PersonalRecordInlineForm";
import { PersonalRecordRow } from "./PersonalRecordRow";

// Personal Record section of Periodization's manage-milestone-goals modal
// (see ~/.claude/plans/periodization-add-goal-modal.md Fase 5/6). Unlike
// Bodyweight (Fase 4), several PRs can pile up over time, so each row carries
// a visibility checkbox (`hiddenFromPlanner`, see PersonalRecordRow.js) - it
// submits immediately on click, same as the pencil/"+ Add New" inline forms
// below it (PersonalRecordInlineForm.js). Every action in this modal is
// immediate-submit - there's no staged/batched state anywhere.
export const PersonalRecordGoalsSection = ({
  clientGoals,
  units,
  query,
  assert,
  flash,
  movementOptions,
  t,
}) => {
  const unitsOptions = getUnitsOptions(t);
  const personalRecordGoals = (clientGoals || []).filter(
    (goal) => goal.type === "personalRecord" && goal.utcTargetDate != null
  );

  const [editingGoalId, setEditingGoalId] = useState(null);
  const [isAddingNew, setIsAddingNew] = useState(false);

  const sharedFormProps = {
    t,
    unitsOptions,
    units,
    movementOptions,
    query,
    assert,
    flash,
  };

  return (
    <div className="goal-section personal-record-goal-section">
      <h3 className="goal-section-title">
        <SvgIcon src="/img/new-icons/golden-star.svg" />
        {t("annualPlanner.personalRecordSectionTitle")}
      </h3>

      {isAddingNew ? (
        <PersonalRecordInlineForm
          {...sharedFormProps}
          onDone={() => setIsAddingNew(false)}
        />
      ) : (
        <button
          type="button"
          className="dashed-box add-goal-ghost-row"
          onClick={() => {
            setIsAddingNew(true);
            setEditingGoalId(null);
          }}
        >
          <span className="add-goal-ghost-label">
            + {t("annualPlanner.addNewPersonalRecord")}
          </span>
        </button>
      )}

      {personalRecordGoals.map((goal) =>
        editingGoalId === goal._id ? (
          <PersonalRecordInlineForm
            key={goal._id}
            {...sharedFormProps}
            goal={goal}
            onDone={() => setEditingGoalId(null)}
          />
        ) : (
          <PersonalRecordRow
            key={goal._id}
            goal={goal}
            units={units}
            query={query}
            t={t}
            onEdit={() => {
              setEditingGoalId(goal._id);
              setIsAddingNew(false);
            }}
          />
        )
      )}
    </div>
  );
};

PersonalRecordGoalsSection.propTypes = {
  clientGoals: PropTypes.array,
  units: PropTypes.string,
  query: PropTypes.object,
  assert: PropTypes.func.isRequired,
  flash: PropTypes.func.isRequired,
  movementOptions: PropTypes.array,
  t: PropTypes.func.isRequired,
};
